const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Formats a "mm-yyyy" near-expiry value (e.g. "08-2026") as "MMM yyyy" (e.g. "Aug 2026"). */
export function formatNearExpiry(value: string | undefined | null): string | undefined {
  if (!value) return undefined;
  const m = /^(\d{2})-(\d{4})$/.exec(value.trim());
  if (!m) return value;
  const monthIdx = Number(m[1]) - 1;
  if (monthIdx < 0 || monthIdx > 11) return value;
  return `${MONTHS[monthIdx]} ${m[2]}`;
}
